document.addEventListener('DOMContentLoaded', function() {
    function updateCookieIframeVisibility() {
      const ageGate = document.getElementById('prompt-background');
      const cookieIframe = document.querySelector('.pieeye-consent-container #myFrame');
      if (cookieIframe) {
        if (ageGate) {
          cookieIframe.style.display = 'none';
        } else {
          cookieIframe.style.display = 'block';
        }
      }
    }
  
    const observer = new MutationObserver(function(mutationsList, observer) {
      updateCookieIframeVisibility();
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    updateCookieIframeVisibility();
  });